const DESIGN_SAVE_DIALOG = {
	message: "編集したデザインを保存しますか?",
	applyMessage: "保存",
};

const DESIGN_RESET_DIALOG = {
	message: "編集したパーツをリセットしますか？",
	applyMessage: "リセット",
	warning: true,
};

const DESIGN_EDIT_DIALOG = {
	message: "選択したデザインを編集しますか？",
	applyMessage: "編集",
};

const DESIGN_DELETE_DIALOG = {
	message: "選択したデザインを削除しますか？",
	applyMessage: "削除",
	warning: true,
};

const ERROR_DIALOG = {
	applyMessage: "OK",
	warning: true,
};

const SAVED_DIALOG = {
	message: "保存しました！",
	applyMessage: "OK",
};

const DESIGN_SAVE_FAILED_DIALOG = {
	message: "保存に失敗しました",
	applyMessage: "OK",
};

export {
	DESIGN_SAVE_DIALOG,
	DESIGN_RESET_DIALOG,
	DESIGN_EDIT_DIALOG,
	DESIGN_DELETE_DIALOG,
	ERROR_DIALOG,
	SAVED_DIALOG,
	DESIGN_SAVE_FAILED_DIALOG,
};
